module.exports = __webpack_public_path__ + "img/oth-logo.b4fba5f2.svg";